import { LEARN } from 'constants/actionTypes';

const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case LEARN.JOURNEY_CONTENTS.RECEIVE:
      return action.journeys;
    default:
      return state;
  }
};
